import './App.css';
import { useState } from 'react';
import { useEffect } from 'react';
import { ethers } from 'ethers';
//import { BigNumber } from 'ethers';
//import Web3 from 'web3';
import contract from './contracts/NftBank.json';
import nftContract from './contracts/NftContract.json';

//const nftBankAddress = "0xcf03dA094A8d67f68e0Cf08D4f329fE38b081ac1"; //old
const nftBankAddress = "0xd4a3c50802fb35587372dAbc224Df0D0d68570dd"; //old
const nftBankAbi = contract.abi;
//const nftAddress = "0x882BAFe66dCe071Cc3f952047F2dDfbf49AD872c"; //old
const nftAddress = "0xfFde94DF5045868D56D60eF849838E8b7B01071e"; //old 
const nftAbi = nftContract.abi;
//const web3 = new Web3(Web3.givenProvider || "http://localhost:8545")
const {ethereum} = window
//var provider =  new ethers.providers.getDefaultProvider('rinkeby');
const provider = new ethers.providers.Web3Provider(ethereum);
const signer = provider.getSigner();
const nftBankContract = new ethers.Contract(nftBankAddress, nftBankAbi, signer);
const nftContractObject = new ethers.Contract(nftAddress, nftAbi, signer);
//const nftBankContractweb3 = new web3.eth.Contract(nftBankAbi, nftBankAddress);
//const nftContractObjectweb3 = new web3.eth.Contract(nftAbi, nftAddress);

  // initWeb3: async function() {
  //   // Modern dapp browsers...
  //   if (window.ethereum) {
  //     App.web3Provider = window.ethereum;
  //     try {
  //       // Request account access
  //       await window.ethereum.enable();
  //     } catch (error) {
  //       // User denied account access...
  //       console.error("User denied account access")
  //     }
  //   }
  //   // Legacy dapp browsers...
  //   else if (window.web3) {
  //     App.web3Provider = window.web3.currentProvider;
  //   }
  //   // If no injected web3 instance is detected, fall back to Ganache
  //   else {
  //     App.web3Provider = new     Web3.providers.HttpProvider('http://localhost:7545');
  //   }
  //   web3 = new Web3(App.web3Provider);

  //   return App.initContract();
  // },



function App() {

  const checkWalletIsConnected = async () => {
    const {ethereum} = window;
    if (!ethereum){
      console.log("Make sure you have Metamask installed!");
      return;
    } else {
      console.log("Metamask is installed!");
    }
    const accounts = await ethereum.request({method: 'eth_accounts'});
    if(accounts.length !== 0){
      const account = accounts[0];
      console.log("Found an athorized account: ", account);
      setCurrentAccount(account);
    } else{
      console.log("No authorized accounnt found")
    }
    
  } 

  const connectWalletHandler = async () => {
    const {ethereum} = window;
    if (!ethereum){
      console.log("Make sure you have Metamask installed!");
    }
    try {
      const accounts = await ethereum.request({method: 'eth_requestAccounts'});
      console.log("Account found! Address: ", accounts[0]);
      setCurrentAccount(accounts[0]);
      } catch (err){
      console.log(err)
    }
  }

  const getOwner = async () => {
    try{
    const {ethereum} = window;

    if(ethereum){
      console.log("Initializig contract call");
      let tx = await nftBankContract.getOwner();
      console.log("Please wait");
      console.log("Contract Owner:", tx);
    } else{
      console.log("Tx object does not exist")
    }
    } catch(err){
      console.log(err);
    }
  }

  const transferOwnership = async (newOwneraddress) => {
        try{
    const {ethereum} = window;

    if(ethereum){
      let tx = await nftBankContract.transferOwnership(newOwneraddress);
      console.log("Please wait");
      let tx2 = await nftBankContract.getOwner();
      console.log("New owner:", tx2);
      //await tx.wait();
      console.log(`Confirmed, see tx at: https://rinkby.etherscan.io/tx/${tx.hash}`);
    } else{
      console.log("Tx object does not exist")
    }
    } catch(err){
      console.log(err);
    }
  }

    const calculateDebt = async (_dealBidded) => {
        try{
    const {ethereum} = window;

    if(ethereum){
      console.log("Please wait debt calculation");
      let debt = await nftBankContract.calculateDebt(_dealBidded);
      console.log("Debt:", debt);
      const debtDiv = document.getElementById("debt");
      const debtTags = ["Debt in ETH: ", debt]
      debtDiv.innerHTML = debtTags
    } else{
      console.log("Tx object does not exist")
    }
    } catch(err){
      console.log(err);
    }
  }

  const CalculateDebtForm = () => {
  const { value:_dealBidded, bind:bind_dealBidded, reset:reset_dealBidded } = useInput('');
  
  const handleSubmit = (evt) => {
      evt.preventDefault();
      alert(`Submitting Owner ${_dealBidded}`);
      reset_dealBidded();
  }
  return (
    
    <form onSubmit={handleSubmit}>
    <h5> Calculate Debt </h5>
      <label>
        Calculate debt of deal bidded (uint):
        <input type="text" {...bind_dealBidded} />
      </label>
      <div id="debt"></div>
      {console.log(_dealBidded)}
      <input type="submit" value="Submit" onClick={() => calculateDebt(_dealBidded)}/>
    </form>
  );
}

    const mintNFT = async (newNft) => {
        try{
    const {ethereum} = window;

    if(ethereum){
      console.log("Please wait MINTING NFT");
      let tx = await nftContractObject.createToken(newNft);
      let itemID = tx.data;
      const iface = new ethers.utils.Interface(['function createToken(string memory tokenURI)'])
      console.log(iface)
      let URI = iface.decodeFunctionData('createToken', tx.data)
      console.log("URI",URI)

      console.log("NFT itemID:", tx);
      console.log("NFT itemID:", itemID);
      console.log(`Confirmed, see tx at: https://rinkby.etherscan.io/tx/${tx.hash}`);
    } else{
      console.log("Tx object does not exist")
    }
    } catch(err){
      console.log(err);
    }
  }

  const setBlockTimeSafety = async () => {
    try{
    const {ethereum} = window;

    if(ethereum){
      console.log("Initialize setBlockTimeSafety");
      let tx = await nftBankContract.setBlockTimeSafety(30);
      console.log("Please wait");
      let tx2 = await nftBankContract.getBlockTimeSafety();
      console.log("BlockTimeSafety:", tx2);
      //await tx.wait();
      console.log(`Confirmed, see tx at: https://rinkby.etherscan.io/tx/${tx.hash}`);
    } else{
      console.log("Tx object does not exist")
    }
    } catch(err){
      console.log(err);
    }
  }

    const FetchLimits = async () => {
    try{
    const {ethereum} = window;

    if(ethereum){
      console.log("Initialize fetchLimits");
     
      const limits = await nftBankContract.fetchLimits()
      console.log(limits)
      const numbersDiv = document.getElementById("numbers");
      const numberTags = ["minInterest", "maxInterest", "minAmount", "maxAmount", "minInterval", "maxInterval"]
      const numbersDescription = '';
      const string_array = [6];
      for (let i = 0; i < numberTags.length; i++)  {
        string_array[i] = numberTags[i]+': '+limits[i];
      }
      console.log("array", string_array)
      numbersDiv.innerHTML = string_array
      console.log(numbersDescription)

      //console.log("maxAmount: ", limits[0], "\n", "maxInterest: ", limits[1], "\n", "maxInterval: ", limits[2], "\n", "minAmount: ", limits[3], "\n","minInterest: ", limits[4], "\n", "minInterval: ",  limits[5])
    
      console.log(`Confirmed, see tx at: https://rinkby.etherscan.io/tx/${limits.hash}`);
      return limits
    } else{
      console.log("Tx object does not exist")
    }
    } catch(err){
      console.log(err);
    }
  }

    const SetupLimitsForm = () => {
   const { value:_minInterest, bind:bind_minInterest, reset:reset_minInterest } = useInput('');
    const { value:_maxInterest, bind:bind_maxInterest, reset:reset_maxInterest } = useInput('');
    const { value:_minAmount, bind:bind_minAmount, reset:reset_minAmount } = useInput('');
    const { value:_maxAmount, bind:bind_maxAmount, reset:reset_maxAmount } = useInput('');
    const { value:_minInterval, bind:bind_minInterval, reset:reset_minInterval } = useInput('');
    const { value:_maxInterval, bind:bind_maxInterval, reset:reset_maxInterval } = useInput('');

  const handleSubmit = (evt) => {
      evt.preventDefault();
      alert(`Submitting new Limits ${_minInterest} ${_maxInterest} ${_minAmount} ${_maxAmount} ${_minInterval} ${_maxInterval}`);
      reset_minInterest();
      reset_maxInterest();
      reset_minAmount();
      reset_maxAmount();
      reset_minInterval();
      reset_maxInterval();
  }
  console.log("testing form")
  return (
    <form onSubmit={handleSubmit}>
    <h5> Set Limits </h5>
      <label>
        minInterest (uint):
        <input type="text" {...bind_minInterest} />
      </label>
      <label>
        maxInterest (uint):
        <input type="text" {...bind_maxInterest} />
      </label>
      <label>
        minAmount (uint):
        <input type="text" {...bind_minAmount} />
      </label>
      <label>
        maxAmount (uint):
        <input type="text" {...bind_maxAmount} />
      </label>
      <label>
        minInterval (uint):
        <input type="text" {...bind_minInterval} />
      </label>
      <label>
        maxInterval (uint):
        <input type="text" {...bind_maxInterval} />
      </label>
      <input type="submit" value="Submit" onClick={() => setupLimits(_minInterest,_maxInterest,_minAmount,_maxAmount,_minInterval,_maxInterval)}/>
    </form>
  );
}

  const setupLimits = async(_minInterest,_maxInterest,_minAmount,_maxAmount,_minInterval,_maxInterval) => {
        try{
    const {ethereum} = window;

    if(ethereum){
      console.log("Please wait");
      let tx = await nftBankContract.setupLimits(_minInterest,_maxInterest,_minAmount,_maxAmount,_minInterval,_maxInterval);
      
      // let filter = {address: nftBankAddress, topics: [ethers.utils.id("DealCreated(uint,address,address,uint,uint,uint,uint)")]}
      // nftBankContract.on(filter, (dealNumber, dealOwner, nftContract, tokenId, maxInterest, maxAmount, dealDate) => {
      // console.log(dealNumber);})
      //let tx2 = await nftBankContract.fetchLimits(nftBankContract.on.dealNumber);
      //console.log("Setup Limits:", tx2);
      console.log(`Confirmed, see tx at: https://rinkby.etherscan.io/tx/${tx.hash}`);
    } else{
      console.log("Tx object does not exist")
    }
    } catch(err){
      console.log(err);
    }
  }

    const getDealCount = async () => {
    try{
    const {ethereum} = window;

    if(ethereum){
      console.log("Initialize getDealCount");
     
      const count = await nftBankContract.getDealCount()
      console.log(count)
      const counterDiv = document.getElementById("counter");
      counterDiv.innerHTML = count
    } else{
      console.log("Tx object does not exist")
    }
    } catch(err){
      console.log(err);
    }
  }

  const useInput = initialValue => {
  const [value, setValue] = useState(initialValue);

  return {
    value,
    setValue,
    reset: () => setValue(""),
    bind: {
      value,
      onChange: event => {
        setValue(event.target.value);
      }
    }
  };
};

  const TransferOwnershipForm = () => {
  const { value:newOwner, bind:bindnewOwner, reset:resetnewOwner } = useInput('');
  
  const handleSubmit = (evt) => {
      evt.preventDefault();
      alert(`Submitting Owner ${newOwner}`);
      resetnewOwner();
  }
  return (
    <form onSubmit={handleSubmit}>
      <label>
      <h5> Trasfer Ownership </h5>
        transferOwnership (Address):
        <input type="text" {...bindnewOwner} />
      </label>
      {console.log(newOwner)}
      <input type="submit" value="Submit" onClick={() => transferOwnership(newOwner)}/>
    </form>
  );
}

 const CreateDealForm = () => {
  const { value:_nftContractObject, bind:bind_nftContractObject, reset:reset_nftContractObject } = useInput('');
  const { value:_tokenID, bind:bind_tokenID, reset:reset_tokenID } = useInput('');
  const { value:_maxInterest, bind:bind_maxInterest, reset:reset_maxInterest } = useInput('');
  const { value:_minAmount, bind:bind_minAmount, reset:reset_minAmount } = useInput('');
  const { value:_maxAmount, bind:bind_maxAmount, reset:reset_maxAmount } = useInput('');
  const { value:_dealDate, bind:bind_dealDate, reset:reset_dealDate } = useInput('');

  const handleSubmit = (evt) => {
      evt.preventDefault();
      alert(`Submitting new Deal ${_nftContractObject}  ${_tokenID} ${_maxInterest} ${_minAmount} ${_maxAmount} ${_dealDate}`);
      reset_nftContractObject();
      reset_tokenID();
      reset_maxInterest();
      reset_minAmount();
      reset_maxAmount();
      reset_dealDate();
  }
  return (
    <form onSubmit={handleSubmit}>
    <h5> Create Deal </h5>
      <label>
        Nft Contract (address):
        <input type="text" {...bind_nftContractObject} />
      </label>
      <label>
        Token ID (uint):
        <input type="text" {...bind_tokenID} />
      </label>
      <label>
        Max Interest you are willig to pay (interest/second):
        <input type="text" {...bind_maxInterest} />
      </label>
      <label>
        Minimum amount to be borrowed (wei):
        <input type="text" {...bind_minAmount} />
      </label>
      <label>
        Maximum amount to be borrowed (wei):
        <input type="text" {...bind_maxAmount} />
      </label>
      <label>
        Due date of the loan (timestamp):
        <input type="text" {...bind_dealDate} />
      </label>   
      <input type="submit" value="Submit" onClick={() => createDeal(_nftContractObject,_tokenID,_maxInterest,_minAmount,_maxAmount,_dealDate)}/>
    </form>
  );
}

  const createDeal = async(_nftContractObject, _tokenID, _maxInterest, _minAmount, _maxAmount, _dealDate) => {
        try{
    const {ethereum} = window;

    if(ethereum){
      console.log("Please wait");
      let tx = await nftBankContract.createDeal(_nftContractObject, _tokenID, _maxInterest, _minAmount, _maxAmount, _dealDate);
      
      let filter = {address: nftBankAddress, topics: [ethers.utils.id("DealCreated(uint,address,address,uint,uint,uint,uint)")]}
      nftBankContract.on(filter, (dealNumber, dealOwner, nftContract, tokenId, maxInterest, maxAmount, dealDate) => {
      console.log(dealNumber);})
      let tx2 = await nftBankContract.fetchDeal(nftBankContract.on.dealNumber);
      console.log("Deal:", tx2);
      console.log(`Confirmed, see tx at: https://rinkby.etherscan.io/tx/${tx.hash}`);
    } else{
      console.log("Tx object does not exist")
    }
    } catch(err){
      console.log(err);
    }
  }
 const InitiateBidForm = () => {
  const { value:_dealBidded, bind:bind_dealBidded, reset:reset_dealBidded } = useInput('');
  const { value:_bidAmount, bind:bind_bidAmount, reset:reset_bidAmount } = useInput('');
  const { value:_bidInterest, bind:bind_bidInterest, reset:reset_bidInterest } = useInput('');

  const handleSubmit = (evt) => {
      evt.preventDefault();
      alert(`Submitting first bid ${_dealBidded}  ${_bidAmount} ${_bidInterest}`);
      reset_dealBidded();
      reset_bidAmount();
      reset_bidInterest();

  }
  return (
    <form onSubmit={handleSubmit}>
    <h5> Initiate Bid </h5>
      <label>
        Nft to be bidded (uint ID):
        <input type="text" {...bind_dealBidded} />
      </label>
      <label>
         Bid amount (uint):
        <input type="text" {...bind_bidAmount} />
      </label>
      <label>
        Bid minimum interest to receive (interest/second):
        <input type="text" {...bind_bidInterest} />
      </label>
      <input type="submit" value="Submit" onClick={() => initiateBid(parseInt(_dealBidded),parseInt(_bidAmount),parseInt(_bidInterest))}/>
      <div id="numbersBid"></div>
    </form>
  );
}
    const initiateBid = async(_dealBidded, _bidAmount, _bidInterest) => {
        try{
    const {ethereum} = window;
    console.log(typeof _dealBidded );
    console.log("_dealBidded before", _dealBidded);
    //const _dealInt = BigNumber.from(_dealBidded.value)
    //console.log("_dealBidded after", _dealInt)
    console.log("_bidAmount before", _bidAmount)
    //const bidAmount= BigNumber.from(_bidAmount)
    //console.log("bidAmount after", bidAmount)
    console.log("_bidInterest before", _bidInterest)
    //const bidInterest= BigNumber.from(_bidInterest)
    //console.log("bidInterest after", bidInterest)
    console.log("toString(currentAccount)",currentAccount);
    console.log("toString(currentAccount)",(currentAccount.toString()));
    console.log("toString(_dealBidded))",(_dealBidded).toString());

    if(ethereum){
      console.log("_dealBidded :", _dealBidded, "_bidAmount :", _bidAmount, "_bidInterest :", _bidInterest)
      console.log("ethers.utils.parseEther", ethers.utils.parseEther(_bidAmount.toString()));
      let tx = await nftBankContract.initiateBid(_dealBidded, _bidAmount, _bidInterest, {value: _bidAmount.toString()});//.send().then(res => console.log('Success', res)).catch(err => console.log(err)) ;
      console.log("Please wait");
      // let filter = {address: nftBankAddress, topics: [ethers.utils.id("updateBidOwnership(uint,uint,uint,address)")]}
      // nftBankContract.on(filter, (dealNumber, bidDate, bidAmount, bidOwner) => {
      // console.log(dealNumber, bidDate, bidAmount, bidOwner);})
      // let tx2 = await nftBankContract.fetchDeal(nftBankContract.on.dealNumber);
      // console.log("Deal:", tx2);
      console.log(`Confirmed, see tx at: https://rinkby.etherscan.io/tx/${tx.hash}`);
    } else{
      console.log("Tx object does not exist")
    }
    } catch(err){
      console.log(err);
    }
    const numbersBid = document.getElementById("numbersBid");
    numbersBid.innerHTML = `${_dealBidded} & ${_bidAmount} & ${_bidInterest}`;
  }

 const DominateBidForm = () => {
  const { value:_dealBidded, bind:bind_dealBidded, reset:reset_dealBidded } = useInput('');
  const { value:_bidAmount, bind:bind_bidAmount, reset:reset_bidAmount } = useInput('');
  const { value:_bidInterest, bind:bind_bidInterest, reset:reset_bidInterest } = useInput('');

  const handleSubmit = (evt) => {
      evt.preventDefault();
      alert(`Submitting dominatig bid ${_dealBidded}  ${_bidAmount} ${_bidInterest}`);
      reset_dealBidded();
      reset_bidAmount();
      reset_bidInterest();

  }
  return (
    <form onSubmit={handleSubmit}>
    <h5> Dominate Bid </h5>
      <label>
        Nft to be bidded (uint ID):
        <input type="text" {...bind_dealBidded} />
      </label>
      <label>
         Bid amount (uint):
        <input type="text" {...bind_bidAmount} />
      </label>
      <label>
        Bid minimum interest to receive (interest/second):
        <input type="text" {...bind_bidInterest} />
      </label>
      <input type="submit" value="Submit" onClick={() => dominateBid(_dealBidded,_bidAmount,_bidInterest)}/>
    </form>
  );
}
     const dominateBid = async(_dealBidded, _bidAmount, _bidInterest) => {
        try{
    const {ethereum} = window;

    if(ethereum){
      let tx = await nftBankContract.domiateBid(_dealBidded, _bidAmount, _bidInterest);
      console.log("Please wait");
      let filter = {address: nftBankAddress, topics: [ethers.utils.id("updateBidOwnership(uint,uint,uint,address)")]}
      nftBankContract.on(filter, (dealNumber, bidDate, bidAmount, bidOwner) => {
      console.log(dealNumber, bidDate, bidAmount, bidOwner);})
      let tx2 = await nftBankContract.fetchDeal(nftBankContract.on.dealNumber);
      console.log("Deal:", tx2);
      console.log(`Confirmed, see tx at: https://rinkby.etherscan.io/tx/${tx.hash}`);
    } else{
      console.log("Tx object does not exist")
    }
    } catch(err){
      console.log(err);
    }
  }

 const PayDebtForm = () => {
  const { value:_dealNumber, bind:bind_dealNumber, reset:reset_dealNumber } = useInput('');

  const handleSubmit = (evt) => {
      evt.preventDefault();
      alert(`Paying Debt ${_dealNumber}`);
      reset_dealNumber();

  }
  return (
    <form onSubmit={handleSubmit}>
    <h5> Pay Debt </h5>
      <label>
        Nft debt ID to be payed (uint ID):
        <input type="text" {...bind_dealNumber} />
      </label>
      <input type="submit" value="Submit" onClick={() => payDebt(_dealNumber)}/>
    </form>
  );
}
     const payDebt = async(_dealNumber) => {
        try{
    const {ethereum} = window;

    if(ethereum){
      let debt = (await nftBankContract.calculateDebt(_dealNumber)).toString();
      console.log("debt",debt);
      let tx = await nftBankContract.payDebt(_dealNumber, {value: debt + 100});
      console.log(`Confirmed, see tx at: https://rinkby.etherscan.io/tx/${tx.hash}`);
      console.log("Please wait");
      let filter = {address: nftBankAddress, topics: [ethers.utils.id("DebtPaid(uint)")]}
      nftBankContract.on(filter, (dealNumber) => {
      console.log(dealNumber);})
      let tx2 = await nftBankContract.fetchDeal(nftBankContract.on.dealNumber);
      console.log("Deal:", tx2);
    } else{
      console.log("Tx object does not exist")
    }
    } catch(err){
      console.log(err);
    }
  }

  const LiquidateNftForm = () => {
  const { value:_dealNumber, bind:bind_dealNumber, reset:reset_dealNumber } = useInput('');

  const handleSubmit = (evt) => {
      evt.preventDefault();
      alert(`Submitting nft liquidation ${_dealNumber}`);
      reset_dealNumber();

  }
  return (
    <form onSubmit={handleSubmit}>
    <h5> Liquidate NFT </h5>
      <label>
        Nft ID to be liquidated (uint ID):
        <input type="text" {...bind_dealNumber} />
      </label>
      <input type="submit" value="Submit" onClick={() => liquidateNft(_dealNumber)}/>
    </form>
  );
}
     const liquidateNft = async(_dealNumber) => {
        try{
    const {ethereum} = window;

    if(ethereum){
      let tx = await nftBankContract.liquidateNft(_dealNumber);
      console.log(`Confirmed, see tx at: https://rinkby.etherscan.io/tx/${tx.hash}`);
      console.log("Please wait");
      let filter = {address: nftBankAddress, topics: [ethers.utils.id("NftLiquidated(uint)")]}
      nftBankContract.on(filter, (dealNumber) => {
      console.log(dealNumber);})
      let tx2 = await nftBankContract.fetchDeal(nftBankContract.on.dealNumber);
      console.log("Deal:", tx2);
    } else{
      console.log("Tx object does not exist")
    }
    } catch(err){
      console.log(err);
    }
  }

  const AddToWhiteListForm = () => {
  const { value:_nftContract, bind:bind_nftContract, reset:reset_nftContract } = useInput('');

  const handleSubmit = (evt) => {
      evt.preventDefault();
      alert(`Submitting nft white-listing ${_nftContract}`);
      reset_nftContract();

  }
  return (
    <form onSubmit={handleSubmit}>
    <h5> Add NFT contract to white list </h5>
      <label>
        Nft cotract to be white-listed (address):
        <input type="text" {...bind_nftContract} />
      </label>
      <input type="submit" value="Submit" onClick={() => addToWhiteList(_nftContract)}/>
    </form>
  );
}
     const addToWhiteList = async(_nftContract) => {
        try{
    const {ethereum} = window;

    if(ethereum){
      let tx = await nftBankContract.addToWhitelist(_nftContract);
      console.log(`Confirmed, see tx at: https://rinkby.etherscan.io/tx/${tx.hash}`);
      console.log("Please wait");
      let filter = {address: nftBankAddress, topics: [ethers.utils.id("nftWhitelistUpdated(uint,bool)")]}
      nftBankContract.on(filter, (nftContract, isWhitelisted) => {
      console.log(nftContract);})
      let tx2 = await nftBankContract.fetchDeal(nftBankContract.on.nftContract);
      console.log("Deal:", tx2);
    } else{
      console.log("Tx object does not exist")
    }
    } catch(err){
      console.log(err);
    }
  }

  const MintNftForm = () => {
  const { value:newNft, bind:bindnewNft, reset:resetnewNft } = useInput('');
  
  const handleSubmit = (evt) => {
      evt.preventDefault();
      alert(`Submitting Nft ${newNft}`);
      resetnewNft();
  }
  return (
    <form onSubmit={handleSubmit}>
    <h5> Mint NFT </h5>
      <label>
        Mint a Nft for test: (URI)
        <input type="text" {...bindnewNft} />
      </label>
      {console.log("Minting a newNft with: ",newNft)}
      <input type="submit" value="Submit" onClick={() => mintNFT(newNft)}/>
    </form>
  );
}
  const connectWalletButton = () => {
    return (
      <button onClick={connectWalletHandler} className='cta-button connect-wallet-button'>
        Connect Wallet
      </button>
    )
  }
  
  const [currentAccount, setCurrentAccount] = useState(null);

  const getOwnerButton = () => {
    return (
      <div>
      <h5> Get Owner </h5>
      <button onClick={getOwner} className='cta-button mint-nft-button'>
        getOwner
      </button>
      </div>
    )
  }

  const setTimeSafetyButton = () => {
    return (
      <div>
      <h5> Set Time Safety betweenn bids </h5>
      <button onClick={setBlockTimeSafety} className='cta-button mint-nft-button'>
      setBlockTimeSafety
      </button>
      </div>
    )
  }

    const fetchLimitsButton = () => {
    return (
      <div>
      <h5> Fetch Limits </h5>
      <button onClick={FetchLimits} className='cta-button mint-nft-button'>
      fetchLimits
      </button>
      <div id="numbers"></div>
      </div>
    )
  }

    const getDealCountButton = () => {
    return (
      <div>
      <h5> Get Number of Deals </h5>
      <button onClick={getDealCount} className='cta-button mint-nft-button'>
      getDealCount
      </button>
      <div id="counter"></div>
      </div>
    )
  }

  const FetchDealForm = () => {
  const { value:_dealNumber, bind:bind_dealNumber, reset:reset_dealNumber } = useInput('');

  const handleSubmit = (evt) => {
      evt.preventDefault();
      alert(`Submitting new Deal ${_dealNumber}`);
      reset_dealNumber();
  }
  return (
    <form onSubmit={handleSubmit}>
    <h5> Get Deal </h5>
      <label>
        Fetch deal by Deal Number (uint):
        <input type="text" {...bind_dealNumber} />
      </label>
      <input type="submit" value="Submit" onClick={() => fetchDeal(_dealNumber)}/>
      <div id="deals"></div>
    </form>
  );
}

  const fetchDeal = async(_dealNumber, _tokenID, _maxInterest, _minAmount, _maxAmount, _dealDate) => {
        try{
    const {ethereum} = window;

    if(ethereum){
      console.log("Please wait");
      let deal = await nftBankContract.fetchDeal(_dealNumber);
      console.log("Deal:", deal);
      console.log(`Confirmed, see deal at: https://rinkby.etherscan.io/${deal.hash}`);

      const dealsDiv = document.getElementById("deals");
      const numberTags = ["dealNumber", "dealOwner", "nftContract", "tokenId", "maxInterest", "minAmount", "maxAmount", "dealDate", "ustate", "bidOwner", "bidDate", "bidAmount", "bidInterest",]
      const string_array = [13];
      for (let i = 0; i < numberTags.length; i++)  {
        string_array[i] = numberTags[i]+': '+ deal[i];
      }
      console.log("array", string_array)
      dealsDiv.innerHTML = string_array

    } else{
      console.log("Tx object does not exist")
    }
    } catch(err){
      console.log(err);
    }
  }

  useEffect(() => {
    checkWalletIsConnected();
  }, [])

  return (
    <div className='main-app'>
      <h1> NFT Lending Bank</h1>
      <div>
      {currentAccount ? getOwnerButton() : connectWalletButton()}
      {fetchLimitsButton()}
      {SetupLimitsForm()}
      {setTimeSafetyButton()}
      {getDealCountButton()}
      {TransferOwnershipForm()}
      {MintNftForm()}
      {CreateDealForm()}
      {InitiateBidForm()}
      {DominateBidForm()}
      {PayDebtForm()}
      {LiquidateNftForm()}
      {AddToWhiteListForm()}
      {FetchDealForm()}
      {CalculateDebtForm()}
      
      <p>  Connected account: {currentAccount}</p>

      </div>
    </div>
  )
}

export default App;